import React, { useState } from 'react'

const Gauge = ({ leftLabel = "Not Recommended", middleLabel = "Consider It", rightLabel = "Recommended", textClassName = "font-bold fill-primary", initialNeedleRotation = 90, needleClassName = "fill-[#C98508] stroke-[#EEEDED] stroke-2", className= "" }) => {
  const [needleRotation, setNeedleRotation] = useState(initialNeedleRotation)

  const handleClick = () => {
    setNeedleRotation((prevRotation) => (prevRotation + 90) % 360)
  }

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="250" viewBox="0 0 250 210" fill="none" onClick={handleClick} className={`transition transform select-none ${className}`}>
      <defs>
        <path id="leftArc" d="M55 190 A90 90 0 0 1 55 60" />
        <path id="topArc" d="M60 55 A90 90 0 0 1 190 55" />
        <path id="rightArc" d="M195 60 A90 90 0 0 1 195 190" />
      </defs>
      
      {/* Left outer arc */}
      <path d="M55.4492 59.9834L36.7244 41.2586C35.4557 39.9899 33.3869 40.052 32.1838 41.3836C-10.7286 88.8726 -10.7279 161.359 32.1857 208.848C33.3879 210.178 35.4551 210.24 36.7229 208.972L55.4495 190.246C21.1366 153.647 21.1366 96.5826 55.4495 59.9837L55.4492 59.9834Z" className='fill-gray-light'/>
      {/* Left inner arc */}
      <path d="M68.7258 125.114C68.7258 111.708 73.4158 99.399 81.2418 89.733C82.248 88.4902 82.1565 86.6905 81.0259 85.5596L55.4492 59.9829C21.1362 96.5818 21.1362 153.646 55.4492 190.245L81.024 164.67C82.1555 163.539 82.2471 161.737 81.2402 160.494C73.4152 150.828 68.7258 138.519 68.7258 125.114Z" className='opacity-30 fill-primary'/>
      {/* Right outer arc */}
      <path d="M194.551 190.245L213.277 208.972C214.545 210.24 216.612 210.177 217.815 208.847C260.728 161.359 260.728 88.8718 217.816 41.3828C216.613 40.0516 214.544 39.9894 213.276 41.2582L194.55 59.9832C228.863 96.5821 228.864 153.646 194.551 190.245Z" className='fill-gray-light'/>
      {/* Right inner arc */}
      <path d="M181.274 125.114C181.274 138.519 176.584 150.828 168.759 160.494C167.752 161.737 167.844 163.538 168.975 164.669L194.551 190.245C228.864 153.646 228.864 96.5818 194.551 59.9829L168.975 85.5589C167.844 86.6899 167.752 88.4905 168.759 89.7337C176.584 99.3996 181.274 111.708 181.274 125.114V125.114Z" className='fill-primary' />
      {/* Top outer arc */}
      <path d="M190.131 55.5634L208.856 36.8383C210.141 35.5537 210.079 33.5165 208.731 32.2983C161.243 -10.614 88.7565 -10.6137 41.2682 32.299C39.9204 33.5168 39.8588 35.5537 41.1435 36.838L59.8692 55.5637C96.4681 21.2508 153.532 21.2508 190.131 55.5637L190.131 55.5634Z" className='fill-gray-light'/>
      {/* Top inner arc */}
      <path d="M125 68.8399C138.406 68.8399 150.714 73.5296 160.38 81.355C161.623 82.3615 163.424 82.27 164.555 81.1387L190.131 55.5633C153.532 21.2504 96.4675 21.2504 59.8687 55.5633L85.4441 81.139C86.5753 82.2703 88.376 82.3619 89.6194 81.3553C99.2854 73.5296 111.594 68.8403 125 68.8403L125 68.8399Z" className='opacity-60 fill-primary'/>
      {/* Gauge needle and center circle */}
      <g transform={`rotate(${needleRotation}, 125, 125), translate(111,111)`}>
        <path d="M93.0551 11.6483L93.0235 11.6445L92.9918 11.6426L24.7066 7.72167C24.1747 6.83076 23.5226 5.99301 22.751 5.23211L22.7509 5.23197C17.8485 0.398921 9.95692 0.454962 5.12385 5.35735C0.29086 10.2596 0.346473 18.1512 5.24889 22.9841C10.151 27.8172 18.0429 27.7611 22.8759 22.8591C23.5975 22.1272 24.2081 21.3277 24.7109 20.4827L92.9989 16.3958L93.0306 16.3939L93.0621 16.39C94.4537 16.2175 95.3306 15.1906 95.3286 14.016C95.3267 12.8417 94.4468 11.8175 93.0551 11.6483ZM13.9997 16.9663C12.4473 16.9663 11.1885 15.7077 11.1885 14.1551C11.1885 12.6024 12.4473 11.3438 13.9997 11.3438C15.5525 11.3438 16.811 12.6023 16.811 14.1551C16.811 15.7078 15.5525 16.9663 13.9997 16.9663Z" className={`${needleClassName}`} />
      </g>
      
      <text fill="#333" fontSize="14" className={textClassName}>
        <textPath href="#leftArc" startOffset="50%" textAnchor="middle">
          <tspan dy="-5">{leftLabel}</tspan>
        </textPath>
      </text>
      
      <text fill="#333" fontSize="14" className={textClassName}>
        <textPath href="#topArc" startOffset="50%" textAnchor="middle">
          <tspan dy="-5">{middleLabel}</tspan>
        </textPath>
      </text>
      
      <text fill="#333" fontSize="14" className={textClassName}>
        <textPath href="#rightArc" startOffset="50%" textAnchor="middle">
          <tspan dy="-5">{rightLabel}</tspan>
        </textPath>
      </text>
    </svg>
  )
}

export default Gauge